import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui } from "@ryde/theme";

export const TableFooterCellReportStyled = styled.th.attrs<IStyledAttributes>({
  "data-e2e": "table-footer-report-cell",
})`
  padding: 6px;
  font-weight: 600;
  font-size: 13px;
  text-align: left;
  color: ${blueGreyMui._900};
  border-top: 1px solid ${greyMui._300};
  div.th_content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    span {
      width: 100%;
    }
  }
`;
